'use client'
import styled from 'styled-components'
import { MenuIcon } from '@shipt/design-system-icons'
import { Skeleton } from '@shipt/design-system-loading'
import { screenSizes } from '@shipt/design-system-themes'
import { Row } from '@shipt/design-system-layouts'
import { HEADER_Z_INDEX } from '@/features/shared/constants/global'
import {
  AutocompletePill,
  CategorySubNavContainer,
  MainHeaderWrapper,
} from '@/features/shared/components/Headers/Header/styles'
import { IconButton } from '@shipt/design-system-buttons'
import { HeaderLogo } from '@/features/shared/components/Headers/HeaderLogo'
import { SkeletonLoader } from '@/features/shared/components/SkeletonLoader'

/*
 * this is a placeholder header component that attempts to mimic the
 * layout of GlobalAnimatedHeader and Header components.
 */
export const HeaderPlaceholder = () => (
  <PlaceholderHeader aria-hidden>
    <TabletBar>
      <MainHeaderWrapper contentMaxWidth as="nav">
        <Row align="center" justify="center" spacing={{ base: 'lg', lg: 'xl' }}>
          <Row spacing="sm" align="center">
            <DummyMenuIconButton />
            <HeaderLogo />
          </Row>
          <AutocompletePill>
            <Skeleton variant="circle" />
          </AutocompletePill>
          <Row spacing="lg" align="center" flexShrink={0}>
            <SkeletonIconButton />
            <SkeletonIconButton />
          </Row>
        </Row>
      </MainHeaderWrapper>
    </TabletBar>
    <MobileBar as="nav" contentMaxWidth>
      <Row justify="space-between" align="center" spacing="xl" flexBasis="100%">
        <DummyMenuIconButton />
        <SkeletonIconButton />
      </Row>
    </MobileBar>
    <SubNavStrip />
  </PlaceholderHeader>
)

const DummyMenuIconButton = () => (
  <IconButton icon={MenuIcon} size="md" variant="ghost" aria-hidden tabIndex={-1} />
)

const SkeletonIconButton = () => (
  <SkeletonLoader isLoading inferSize variant="circle">
    <DummyMenuIconButton />
  </SkeletonLoader>
)

const PlaceholderHeader = styled.header`
  width: 100%;
  z-index: ${HEADER_Z_INDEX};
  top: 0;
  position: sticky;
`

const TabletBar = styled.div`
  background-color: ${({ theme }) => theme.color.background.base.neutral.subtle_00};

  @media ${screenSizes.max_mobile} {
    display: none;
  }
`

const MobileBar = styled(MainHeaderWrapper)`
  background-color: ${({ theme }) => theme.color.background.base.neutral.subtle_00};

  @media ${screenSizes.tablet} {
    display: none;
  }
`

const SubNavStrip = styled(CategorySubNavContainer)`
  border-bottom: 0.5px solid
    ${({ theme }) => theme.color.border.base.neutral.subtle};

  @media ${screenSizes.max_mobile} {
    display: none;
  }
`
